module.exports = __webpack_public_path__ + "img/znghs.d87ffa89.png";